import { Box, TextField, Typography } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DatePickerYearMonth = (props) => {
    const [value, setValue] = useState(dayjs());
    return (
        <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    {...props}
                    views={['year','month']}
                    value={value}
                    onChange={(newValue) => {
                        props?.setValue(newValue.format("YYYY-MM"))
                        setValue(newValue)
                    }}
                    PopperProps={{
                        sx: {
                          "& .MuiPaper-root": {
                            margin: "5px 0 0 -40px",
                            borderRadius: "10px",
                          }
                        },
                      }}
                    maxDate={dayjs()}
                    renderInput={(params) => 
                    <>
                    <Typography variant="h7">Select month and year</Typography>
                    <TextField
                        {...params}
                        sx={{
                            "& .MuiSvgIcon-root": {
                                height: "20px",
                            },
                            "& .MuiInputBase-input": {
                                height: "7px",
                            },
                        }}
                    />
                    </>}
                />
            </LocalizationProvider>
        </Box>
    );
};

export default DatePickerYearMonth;
